import defaults from './auditDefaults.js'

const state = Object.assign({}, defaults)
export default state
